import { isAfter } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { parseTime } from '../../utils/datetime';
import { zDayOfWeek, zServiceType } from '../enums';

export const serviceHourSchema = z.object({
  /** ISO Time (Local), eg 'T16:00' */
  closes: z.string(),
  daysOfWeek: z.array(zDayOfWeek).default([]),
  isSpecialHour: z.boolean().default(false), // TODO: Remove this field, and detect if specialHourValidFrom OR specialHourValidUntil has value instead.
  /** ISO Time (Local), eg 'T00:00' */
  opens: z.string(),
  serviceType: zServiceType,
  /** ISO Date, eg '2022-12-20' */
  specialHourValidFrom: z.iso.date().nullable().default(null),
  /** ISO Date, eg '2022-12-20' */
  specialHourValidUntil: z.iso.date().nullable().default(null),
  uuid: z.string().default(() => uuidv4()),
});
export type ServiceHour = z.output<typeof serviceHourSchema>;

/** Strict schema */
export const serviceHourStrictSchema = serviceHourSchema
  .safeExtend({
    uuid: z.guid(),
  })
  /** Validation: Check if closes time is after opens time **/
  .refine(
    (data) => {
      const opensTime = parseTime(data.opens);
      const closesTime = parseTime(data.closes);
      return isAfter(closesTime, opensTime);
    },
    {
      message: 'Close time must be after open time',
      path: ['closes'],
    },
  );
